import { CSSProperties } from "react";

interface WOLTheme {
  contentBorderBoxShadow: CSSProperties["boxShadow"];
  mainContentPadding: number;
  gradientBackground: CSSProperties["background"];
  font: {
    primary: {
      color: CSSProperties["color"];
    };
    secondary: {
      color: CSSProperties["color"];
    };
  };
}

const LightTheme: WOLTheme = {
  contentBorderBoxShadow: "0 0 2px rgb(166 171 189 / .9)",
  mainContentPadding: 20,
  gradientBackground:
    "linear-gradient(135deg, rgba(143, 35, 152, 1) 20%, rgba(62, 147, 211, 1) 100%, rgba(143, 35, 152, 1) 143%);",
  font: {
    primary: {
      color: "black",
    },
    secondary: {
      color: "#60616d",
    },
  },
};

export default LightTheme;
